import React, { useEffect, useState, useRef } from 'react';
import { Sparkles, Play, Pause, Check, Shield, AlertTriangle, Download, Star, ChevronDown, ChevronUp, Lock, Menu, X, ArrowRight } from 'lucide-react';
import { MatrixBackground } from '../components/MatrixBackground';
import { SalesNotification } from '../components/SalesNotification';
import { LanguageProvider, useLanguage } from '../context/LanguageContext';
function LP2Content() {
  const {
    setLanguage
  } = useLanguage();
  useEffect(() => {
    setLanguage('es');
  }, [setLanguage]);
  const [isPlaying, setIsPlaying] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  // Audio player state
  const audioRef = useRef<HTMLAudioElement>(null);
  const togglePlay = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
    setShowMobileMenu(false);
  };
  return <div className="min-h-screen bg-black text-gray-200 font-sans selection:bg-teal-500/30" data-id="element-668">
      <div className="fixed inset-0 pointer-events-none opacity-40" style={{
      zIndex: 0
    }} data-id="element-669">
        <MatrixBackground data-id="element-670" />
      </div>
      <SalesNotification data-id="element-671" />

      {/* Top Bar / Notification */}
      <div className="bg-black/80 border-b border-teal-500/20 backdrop-blur-sm sticky top-0 z-50" data-id="element-672">
        <div className="max-w-6xl mx-auto px-4 py-2 flex justify-between items-center text-xs md:text-sm" data-id="element-673">
          <div className="flex items-center gap-2" data-id="element-674">
            <span className="relative flex h-2 w-2" data-id="element-675">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-676"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" data-id="element-677"></span>
            </span>
            <span className="text-teal-100" data-id="element-678">
              <span className="font-bold" data-id="element-679">Compra reciente:</span> Andrew L. de
              Dallas, TX compró{' '}
              <span className="text-yellow-400" data-id="element-680">Pack Despertar</span>.
            </span>
          </div>
          <button onClick={() => scrollToSection('pricing')} className="hidden md:block bg-yellow-500 hover:bg-yellow-400 text-black font-bold px-4 py-1 rounded-full text-xs transition-colors" data-id="element-681">
            ACCEDER AHORA
          </button>
        </div>
      </div>

      {/* Hero Section */}
      <section className="relative z-10 pt-12 pb-6 px-4 overflow-hidden" data-id="element-682">
        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-683">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-teal-900/30 border border-teal-500/30 mb-6" data-id="element-684">
            <Sparkles className="w-4 h-4 text-yellow-400" data-id="element-685" />
            <span className="text-sm font-medium text-teal-200 uppercase tracking-wider" data-id="element-686">
              Nuevo Manual de Consciencia
            </span>
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight tracking-tight" data-id="element-687">
            ¿Quieres Despertar de la Matrix…{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-200" data-id="element-688">
              Sin Perderte a Ti Mismo?
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-689">
            Este libro transformador revela{' '}
            <span className="text-white font-bold" data-id="element-690">7 Códigos Ocultos</span> para
            recordar quién eres realmente — y empezar a jugar el verdadero juego
            de la vida, desde hoy.
          </p>

          <div className="bg-teal-950/30 border border-teal-500/20 rounded-xl p-6 mb-10 max-w-2xl mx-auto backdrop-blur-sm" data-id="element-691">
            <p className="text-lg text-teal-100" data-id="element-692">
              <span className="font-bold text-white" data-id="element-693">
                En los próximos 90 minutos
              </span>{' '}
              puedes sentir el primer cambio real: pasar de reaccionar en piloto
              automático a ver el tablero con claridad (sin dogmas, sin gurús,
              sin caer en paranoia espiritual).
            </p>
          </div>

          <div className="flex flex-col items-center gap-4" data-id="element-694">
            <button onClick={() => scrollToSection('pricing')} className="w-full md:w-auto bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-400 hover:to-yellow-500 text-black font-bold text-xl px-8 py-4 rounded-full shadow-[0_0_20px_rgba(234,179,8,0.3)] hover:shadow-[0_0_30px_rgba(234,179,8,0.5)] transition-all transform hover:scale-105" data-id="element-695">
              SÍ — ESTOY LISTO PARA JUGAR
            </button>
            <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-400 mt-2" data-id="element-696">
              <span className="flex items-center gap-1" data-id="element-697">
                <Check className="w-4 h-4 text-green-500" data-id="element-698" /> Descarga
                instantánea
              </span>
              <span className="flex items-center gap-1" data-id="element-699">
                <Check className="w-4 h-4 text-green-500" data-id="element-700" /> Lee en cualquier
                dispositivo
              </span>
              <span className="flex items-center gap-1" data-id="element-701">
                <Check className="w-4 h-4 text-green-500" data-id="element-702" /> Audiolibro incluido
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Audio Subhero */}
      <section className="relative z-10 py-8 px-4 bg-gradient-to-b from-black to-teal-950/40" data-id="element-703">
        <div className="max-w-3xl mx-auto bg-gray-900 border border-gray-700 rounded-2xl p-6 md:p-8 shadow-2xl" data-id="element-704">
          <div className="flex flex-col md:flex-row items-center gap-6" data-id="element-705">
            <div className="flex-shrink-0 bg-teal-900/50 rounded-full p-4" data-id="element-706">
              <button onClick={togglePlay} className="w-16 h-16 flex items-center justify-center bg-yellow-500 hover:bg-yellow-400 text-black rounded-full transition-all shadow-lg" data-id="element-707">
                {isPlaying ? <Pause className="w-8 h-8 fill-current" data-id="element-708" /> : <Play className="w-8 h-8 fill-current ml-1" data-id="element-709" />}
              </button>
            </div>
            <div className="flex-1 text-center md:text-left" data-id="element-710">
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-711">
                Escucha la introducción
              </h3>
              <p className="text-gray-400 text-sm mb-4" data-id="element-712">
                (1:49:47 audiolibro completo incluido)
              </p>
              <div className="h-2 bg-gray-700 rounded-full overflow-hidden mb-2" data-id="element-713">
                <div className={`h-full bg-yellow-500 transition-all duration-1000 ${isPlaying ? 'w-full animate-pulse' : 'w-0'}`} data-id="element-714"></div>
              </div>
              <p className="text-teal-200 font-medium italic" data-id="element-715">
                "Dale play y siente si esto es para ti. (Si tu cuerpo dice "sí",
                tu mente ya va tarde.)"
              </p>
            </div>
          </div>
          <audio ref={audioRef} src="https://share.deal.ai/files/6902f93c500a402c689c3020/d71e663b-2ff1-4919-8ed0-156f7315d3ca" preload="metadata" crossOrigin="anonymous" style={{
          position: 'absolute',
          width: 0,
          height: 0,
          opacity: 0
        }} onEnded={() => setIsPlaying(false)} data-id="element-716" />
        </div>
      </section>

      {/* Social Proof */}
      <section className="relative z-10 py-16 px-4 border-y border-gray-800 bg-black" data-id="element-717">
        <div className="max-w-5xl mx-auto text-center" data-id="element-718">
          <h3 className="text-lg md:text-xl text-gray-400 mb-8" data-id="element-719">
            Confiado por lectores despertando en{' '}
            <span className="text-white font-bold" data-id="element-720">más de 25 países</span>
          </h3>
          <p className="text-sm text-teal-500 mb-10 uppercase tracking-widest font-semibold" data-id="element-721">
            Destacado en círculos espirituales que exploran consciencia,
            energía, DMT y el fenómeno de la "Matrix"
          </p>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-722">
            {[{
            quote: 'Sentí como si estuviera recordando algo ancestral.',
            author: 'E.M.'
          }, {
            quote: 'Cada párrafo desmanteló una creencia que no sabía que era programación.',
            author: 'S.T.'
          }, {
            quote: 'Dejé de luchar contra la vida y comencé a jugar con ella — y todo cambió.',
            author: 'L.R.'
          }].map((testimonial, i) => <div key={i} className="bg-gray-900/50 p-6 rounded-xl border border-gray-800" data-id="element-723">
                <div className="flex justify-center gap-1 mb-4" data-id="element-724">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 text-yellow-500 fill-current" data-id="element-725" />)}
                </div>
                <p className="text-gray-300 italic mb-4" data-id="element-726">
                  "{testimonial.quote}"
                </p>
                <p className="text-teal-400 font-bold text-sm" data-id="element-727">
                  — {testimonial.author}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Pain / Identification */}
      <section className="relative z-10 py-20 px-4 bg-black" data-id="element-728">
        <div className="max-w-4xl mx-auto" data-id="element-729">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 text-center" data-id="element-730">
            Si eres como la mayoría de los buscadores…{' '}
            <span className="text-red-400" data-id="element-731">
              estás cansado de sentir que falta algo.
            </span>
          </h2>
          <p className="text-xl text-gray-400 text-center mb-12" data-id="element-732">
            Como si hubieras nacido para más…{' '}
            <span className="text-white" data-id="element-733">pero no puedes recordar qué.</span>
          </p>

          <div className="bg-gray-900 p-8 rounded-2xl border border-gray-800 shadow-xl" data-id="element-734">
            <p className="text-lg text-teal-200 mb-6 font-semibold" data-id="element-735">
              En este momento, probablemente estás:
            </p>
            <ul className="space-y-4 mb-8" data-id="element-736">
              {['Persiguiendo éxito pero sintiéndote vacío por dentro', 'Viendo a otros "manifestar" mientras tú luchas con caos, ansiedad o miedo', 'Abrumado por consejos infinitos de "sanación" que nunca se sostienen', 'Preguntándote por qué los mismos patrones se repiten (diferentes caras, el mismo dolor)', 'Frustrado porque sabes que la realidad es más profunda… pero no logras ver el código detrás'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-737">
                  <div className="mt-1 min-w-[20px]" data-id="element-738">
                    <X className="w-5 h-5 text-red-500" data-id="element-739" />
                  </div>
                  <span className="text-gray-300" data-id="element-740">{item}</span>
                </li>)}
            </ul>
            <div className="p-6 bg-red-900/10 border border-red-900/30 rounded-xl" data-id="element-741">
              <p className="text-gray-200 mb-4" data-id="element-742">
                Y cada día que sigues ejecutando el programa viejo, pierdes:{' '}
                <span className="font-bold text-white" data-id="element-743">
                  tiempo, energía, claridad… y la oportunidad de recordar por
                  qué viniste aquí.
                </span>
              </p>
              <p className="text-lg font-medium text-white" data-id="element-744">
                <span className="text-red-400 font-bold" data-id="element-745">Lo peor:</span> el
                sistema se alimenta de tu distracción, mientras tu alma susurra:{' '}
                <span className="text-yellow-400 italic" data-id="element-746">
                  "Despierta… tú eres el jugador."
                </span>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Big Idea */}
      <section className="relative z-10 py-20 px-4 bg-teal-950/40" data-id="element-747">
        <div className="max-w-4xl mx-auto text-center" data-id="element-748">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-8" data-id="element-749">
            Estamos en la mayor ventana de despertar de la historia humana.
          </h2>
          <p className="text-xl text-teal-100 mb-12" data-id="element-750">
            Tecnología, energía y consciencia están colisionando… pero la
            mayoría sigue hipnotizada por la simulación.
          </p>

          <div className="grid md:grid-cols-3 gap-8 mb-12 text-left" data-id="element-751">
            <div className="bg-black/40 p-6 rounded-xl border border-teal-900/50" data-id="element-752">
              <p className="text-gray-300" data-id="element-753">
                La física moderna y la observación consciente muestran que{' '}
                <span className="text-white font-bold" data-id="element-754">
                  la realidad responde a la percepción
                </span>
              </p>
            </div>
            <div className="bg-black/40 p-6 rounded-xl border border-teal-900/50" data-id="element-755">
              <p className="text-gray-300" data-id="element-756">
                Sistemas basados en miedo y jerarquía se están{' '}
                <span className="text-white font-bold" data-id="element-757">agrietando</span>
              </p>
            </div>
            <div className="bg-black/40 p-6 rounded-xl border border-teal-900/50" data-id="element-758">
              <p className="text-gray-300" data-id="element-759">
                Los que aprenden a jugar conscientemente{' '}
                <span className="text-white font-bold" data-id="element-760">
                  reescriben el juego colectivo
                </span>
              </p>
            </div>
          </div>

          <div className="inline-block bg-yellow-900/20 border border-yellow-600/30 px-6 py-4 rounded-lg" data-id="element-761">
            <p className="text-yellow-200 font-medium" data-id="element-762">
              Esta ventana no permanece abierta para siempre. Si demoras, el
              código se cierra a tu alrededor otra vez… y vuelves al loop.
            </p>
          </div>
        </div>
      </section>

      {/* Warning */}
      <section className="relative z-10 py-12 px-4 bg-black" data-id="element-763">
        <div className="max-w-3xl mx-auto bg-white text-black p-6 md:p-8 rounded-xl border-l-8 border-orange-500 shadow-2xl" data-id="element-764">
          <div className="flex items-start gap-4" data-id="element-765">
            <AlertTriangle className="w-8 h-8 text-orange-600 flex-shrink-0" data-id="element-766" />
            <div data-id="element-767">
              <h3 className="text-xl font-bold text-orange-800 mb-2" data-id="element-768">
                ADVERTENCIA
              </h3>
              <p className="text-lg leading-relaxed" data-id="element-769">
                Lo que estás a punto de leer puede desafiar todo lo que te
                enseñaron sobre la realidad… y eso es exactamente lo que lo hace
                liberador.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Origin Story */}
      <section className="relative z-10 py-20 px-4 bg-black" data-id="element-770">
        <div className="max-w-3xl mx-auto" data-id="element-771">
          <div className="border-l-2 border-teal-800 pl-6 md:pl-10 py-4" data-id="element-772">
            <p className="text-teal-500 font-mono mb-1" data-id="element-773">De: Gabriel Beltrán</p>
            <p className="text-teal-500 font-mono mb-8" data-id="element-774">
              Ubicación: Tierra, Densidad Nivel 3
            </p>

            <div className="space-y-6 text-lg text-gray-300 leading-relaxed" data-id="element-775">
              <p data-id="element-776">
                Una vez viví dormido dentro del sistema: trabajar, lograr,
                repetir… y aun así sentir que "algo" faltaba.
              </p>
              <p data-id="element-777">Hasta que un día, todo se quebró.</p>
              <p data-id="element-778">
                Me di cuenta de algo incómodo (pero poderoso):{' '}
                <span className="text-white font-bold bg-teal-900/30 px-1" data-id="element-779">
                  mi vida no era aleatoria. Estaba programada.
                </span>
              </p>
              <p data-id="element-780">
                Pero en lugar de pánico, sentí claridad: "¿Y si esto es un
                juego… y puedo recordar las reglas?"
              </p>
              <p data-id="element-781">
                Ese camino — investigación, práctica de consciencia, observación
                profunda y un puente entre sabiduría antigua y lenguaje moderno
                — se convirtió en:
              </p>
            </div>
          </div>

          <div className="mt-12 text-center" data-id="element-782">
            <h2 className="text-4xl md:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-blue-500 mb-4" data-id="element-783">
              ¿ESTÁS LISTO PARA JUGAR?
            </h2>
            <p className="text-xl text-gray-400" data-id="element-784">
              Un manual para almas que ya terminaron de obedecer al miedo… y
              están listas para crear conscientemente.
            </p>
          </div>
        </div>
      </section>

      {/* Promise / Vision */}
      <section className="relative z-10 py-20 px-4 bg-gray-900" data-id="element-785">
        <div className="max-w-4xl mx-auto text-center" data-id="element-786">
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-8" data-id="element-787">
            Antes de ver lo que hay dentro, imagina esto:
          </h3>
          <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-788">
            <div className="text-left space-y-4" data-id="element-789">
              <div className="flex items-center gap-3" data-id="element-790">
                <div className="w-2 h-2 bg-teal-500 rounded-full" data-id="element-791"></div>
                <p className="text-gray-300" data-id="element-792">
                  Te despiertas mañana con una sensación rara… pero deliciosa:{' '}
                  <span className="text-white font-bold" data-id="element-793">claridad.</span>
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-794">
                <div className="w-2 h-2 bg-teal-500 rounded-full" data-id="element-795"></div>
                <p className="text-gray-300" data-id="element-796">
                  Dejas de perseguir significado porque{' '}
                  <span className="text-white font-bold" data-id="element-797">
                    tú eres el significado.
                  </span>
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-798">
                <div className="w-2 h-2 bg-teal-500 rounded-full" data-id="element-799"></div>
                <p className="text-gray-300" data-id="element-800">El miedo pierde volumen.</p>
              </div>
              <div className="flex items-center gap-3" data-id="element-801">
                <div className="w-2 h-2 bg-teal-500 rounded-full" data-id="element-802"></div>
                <p className="text-gray-300" data-id="element-803">
                  Las sincronicidades empiezan a responder como "feedback".
                </p>
              </div>
            </div>
            <div className="bg-teal-900/10 p-8 rounded-2xl border border-teal-500/20" data-id="element-804">
              <p className="text-xl font-medium text-teal-100 italic" data-id="element-805">
                "No porque el mundo sea perfecto… sino porque tú ya no estás
                dormido dentro de él."
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Others Fail */}
      <section className="relative z-10 py-20 px-4 bg-black" data-id="element-806">
        <div className="max-w-3xl mx-auto text-center" data-id="element-807">
          <h2 className="text-3xl font-bold text-red-400 mb-6" data-id="element-808">
            La mayoría intenta cambiar su vida desde el lugar equivocado.
          </h2>
          <p className="text-lg text-gray-300 mb-8" data-id="element-809">
            Afirmaciones. Técnicas. Ritualitos. "Sanación" infinita. Y aun así…
            vuelves al mismo patrón.
          </p>
          <div className="bg-gray-900 p-8 rounded-xl border border-gray-800" data-id="element-810">
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-811">¿Por qué?</h3>
            <p className="text-gray-300 mb-6" data-id="element-812">
              Porque estás intentando arreglar el juego{' '}
              <span className="text-white font-bold underline decoration-red-500" data-id="element-813">
                desde el personaje.
              </span>
            </p>
            <div className="flex flex-wrap justify-center gap-3 mb-8" data-id="element-814">
              {['supervivencia', 'comparación', 'control', 'miedo al tiempo', 'identidad rígida'].map((tag, i) => <span key={i} className="px-3 py-1 bg-red-900/20 text-red-300 rounded-full text-sm border border-red-900/30" data-id="element-815">
                  {tag}
                </span>)}
            </div>
            <p className="text-xl font-bold text-white" data-id="element-816">
              El problema no eres tú.{' '}
              <span className="text-teal-400" data-id="element-817">El problema es el modo.</span>
            </p>
          </div>
        </div>
      </section>

      {/* Unique Mechanism */}
      <section className="relative z-10 py-20 px-4 bg-teal-950/40" data-id="element-818">
        <div className="max-w-4xl mx-auto" data-id="element-819">
          <div className="text-center mb-12" data-id="element-820">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-821">
              La solución es activar{' '}
              <span className="text-yellow-400" data-id="element-822">Los 7 Códigos del Jugador</span>
            </h2>
            <p className="text-xl text-gray-300" data-id="element-823">
              Esto no es otro libro motivacional. Es un{' '}
              <span className="font-bold text-white" data-id="element-824">manual</span>.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-825">
            <div className="space-y-4" data-id="element-826">
              {['Ver el sistema oculto que dirige tu vida', 'Recordar tu origen y propósito', 'Reescribir tu realidad a través de consciencia aplicada', 'Salir del loop sin "escapar del mundo"'].map((item, i) => <div key={i} className="flex items-center gap-4 bg-black p-4 rounded-lg border border-teal-900/50" data-id="element-827">
                  <div className="w-8 h-8 flex items-center justify-center bg-teal-900 rounded-full text-teal-400 font-bold" data-id="element-828">
                    {i + 1}
                  </div>
                  <p className="text-gray-200" data-id="element-829">{item}</p>
                </div>)}
            </div>
            <div className="flex items-center justify-center bg-gradient-to-br from-teal-900/20 to-black p-8 rounded-2xl border border-teal-500/20" data-id="element-830">
              <div className="text-center" data-id="element-831">
                <p className="text-lg text-gray-300 mb-2" data-id="element-832">La diferencia:</p>
                <p className="text-2xl font-bold text-white" data-id="element-833">
                  Aquí no "crees".
                </p>
                <p className="text-3xl font-black text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-200 mt-2" data-id="element-834">
                  Aquí ves, entiendes y aplicas.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Content Modules */}
      <section className="relative z-10 py-20 px-4 bg-black" data-id="element-835">
        <div className="max-w-4xl mx-auto" data-id="element-836">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-12" data-id="element-837">
            Esto es lo que obtienes al ordenar{' '}
            <span className="text-teal-400" data-id="element-838">¿Estás Listo Para Jugar?</span>
          </h2>

          <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-839">
            {[{
            title: 'MÓDULO 1 — El Velo Revelado',
            desc: 'Descubre por qué olvidaste quién eres… y cómo empieza el recuerdo real (sin fantasía).'
          }, {
            title: 'MÓDULO 2 — Las Reglas Ocultas del Sistema',
            desc: 'Entiende cómo el miedo, el tiempo y la identidad te mantienen dormido.'
          }, {
            title: 'MÓDULO 3 — La Secuencia del Despertar',
            desc: 'Proceso paso a paso para activar el juego consciente en tu vida diaria.'
          }, {
            title: 'MÓDULO 4 — El Plan del Juego Infinito',
            desc: 'Aprende a crear realidad desde amor… no desde supervivencia.'
          }].map((module, i) => <div key={i} className="bg-gray-900 p-6 rounded-xl border border-gray-800 hover:border-teal-500/50 transition-colors" data-id="element-840">
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-841">
                  {module.title}
                </h3>
                <p className="text-gray-400" data-id="element-842">{module.desc}</p>
              </div>)}
          </div>

          <div className="text-center" data-id="element-843">
            <button onClick={() => scrollToSection('pricing')} className="bg-white text-black hover:bg-gray-200 font-bold text-lg px-8 py-4 rounded-full transition-colors" data-id="element-844">
              SÍ — QUIERO EL MANUAL Y EL AUDIO
            </button>
          </div>
        </div>
      </section>

      {/* Micro-Proof */}
      <section className="relative z-10 py-16 px-4 bg-gray-900 border-y border-gray-800" data-id="element-845">
        <div className="max-w-4xl mx-auto text-center" data-id="element-846">
          <h3 className="text-2xl font-bold text-white mb-8" data-id="element-847">
            En solo días, muchos lectores reportan:
          </h3>
          <div className="flex flex-wrap justify-center gap-4 md:gap-8 mb-10" data-id="element-848">
            {['Paz radical reemplazando ansiedad', 'Sensación eléctrica de "recuerdo"', 'Sincronicidades que confirman el cambio', 'Menos necesidad de buscar afuera'].map((item, i) => <div key={i} className="flex items-center gap-2 bg-black px-4 py-2 rounded-full border border-teal-900/50" data-id="element-849">
                <Check className="w-4 h-4 text-teal-400" data-id="element-850" />
                <span className="text-sm md:text-base text-gray-300" data-id="element-851">
                  {item}
                </span>
              </div>)}
          </div>
          <div className="inline-block relative" data-id="element-852">
            <p className="text-xl md:text-2xl font-serif italic text-teal-200 px-8" data-id="element-853">
              "Dejé de luchar contra la vida y comencé a jugar con ella."
            </p>
            <p className="text-right text-sm text-teal-500 font-bold mt-2" data-id="element-854">
              — L.R.
            </p>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="relative z-10 py-20 px-4 bg-black" data-id="element-855">
        <div className="max-w-5xl mx-auto" data-id="element-856">
          <h2 className="text-3xl md:text-5xl font-bold text-center text-white mb-4" data-id="element-857">
            Elige tu acceso
          </h2>
          <p className="text-center text-gray-400 mb-12" data-id="element-858">
            (descarga instantánea)
          </p>

          <div className="grid md:grid-cols-2 gap-8 items-stretch" data-id="element-859">
            {/* Option A - Digital */}
            <div className="bg-gray-900 border border-gray-700 rounded-2xl p-8 flex flex-col relative overflow-hidden" data-id="element-860">
              <div className="mb-6" data-id="element-861">
                <h3 className="text-2xl font-bold text-white mb-2" data-id="element-862">
                  Opción A — Edición Digital
                </h3>
              </div>

              <div className="flex justify-center mb-6" data-id="element-863">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oyz5GB8MJJnmomK7GwM4JC/Generated_Image_October_27%2C_2025_-_5_59PM.png" alt="Edición Digital" className="w-full max-w-xs rounded-lg shadow-2xl shadow-blue-500/20" data-id="element-864" />
              </div>

              <div className="text-center mb-6" data-id="element-865">
                <p className="text-gray-500 line-through text-lg" data-id="element-866">$47</p>
                <div className="text-4xl font-bold text-white mb-1" data-id="element-867">$17</div>
                <p className="text-sm text-gray-400" data-id="element-868">Pago único</p>
              </div>

              <div className="flex-1 space-y-4 mb-8" data-id="element-869">
                <p className="font-semibold text-white" data-id="element-870">Incluye:</p>
                <ul className="space-y-3" data-id="element-871">
                  <li className="flex items-start gap-3 text-gray-300" data-id="element-872">
                    <Check className="w-5 h-5 text-blue-500 flex-shrink-0" data-id="element-873" />
                    Acceso digital instantáneo
                  </li>
                  <li className="flex items-start gap-3 text-gray-300" data-id="element-874">
                    <Check className="w-5 h-5 text-blue-500 flex-shrink-0" data-id="element-875" />
                    eBook (lee en cualquier dispositivo)
                  </li>
                  <li className="flex items-start gap-3 text-gray-300" data-id="element-876">
                    <Check className="w-5 h-5 text-blue-500 flex-shrink-0" data-id="element-877" />
                    <span className="font-bold text-white" data-id="element-878">
                      Audiolibro completo incluido
                    </span>{' '}
                    (1:49:47)
                  </li>
                </ul>

                <div className="bg-green-900/20 p-4 rounded-lg border border-green-500/30 mt-6" data-id="element-879">
                  <p className="text-sm font-bold text-green-400 mb-2" data-id="element-880">
                    🎁 BONO GRATIS:
                  </p>
                  <div className="flex justify-center mb-3" data-id="element-881">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dGUuFum1oJN8EtXx9jvzFz/Generated_Image_October_29%2C_2025_-_4_16PM_%282%29.png" alt="DMT: La Molécula Espiritual" className="w-24 h-auto rounded shadow-lg shadow-green-500/20" data-id="element-882" />
                  </div>
                  <p className="text-sm font-bold text-white mb-1" data-id="element-883">
                    DMT: La Molécula Espiritual
                  </p>
                  <p className="text-xs text-gray-300 mb-2" data-id="element-884">
                    Audiolibro + Libro Digital
                  </p>
                  <p className="text-green-400 font-bold text-sm mb-3" data-id="element-885">
                    ($39.97 Valor) — GRATIS
                  </p>
                  <audio controls controlsList="nodownload" crossOrigin="anonymous" className="w-full h-10 rounded" preload="metadata" style={{
                  backgroundColor: '#1f2937',
                  outline: 'none'
                }} data-id="element-886">
                    <source src="https://share.deal.ai/files/6903cecd11c178905f921b0c/d87748c2-120b-4958-a11e-5ae4b9dda06b" type="audio/mpeg" data-id="element-887" />
                  </audio>
                </div>
              </div>

              <a href="https://www.voicesoffreedomus.com/cart/45280183124154:1" className="block w-full bg-blue-600 hover:bg-blue-500 text-white font-bold text-center py-4 rounded-xl transition-colors" data-id="element-888">
                OBTENER EDICIÓN DIGITAL
              </a>
            </div>

            {/* Option B - Bundle */}
            <div className="bg-gradient-to-b from-gray-900 to-black border-2 border-yellow-500 rounded-2xl p-8 flex flex-col relative shadow-[0_0_30px_rgba(234,179,8,0.15)] transform md:-translate-y-4" data-id="element-889">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 bg-yellow-500 text-black text-xs font-bold px-4 py-1 rounded-b-lg uppercase tracking-wider" data-id="element-890">
                ⭐ Best Seller
              </div>

              <div className="mb-6 mt-4" data-id="element-891">
                <h3 className="text-2xl font-bold text-yellow-400 mb-2" data-id="element-892">
                  Opción B — Pack Despertar
                </h3>
              </div>

              <div className="flex justify-center mb-6" data-id="element-893">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4MVrzFAKrfHoGQy7en26dD/BUNDLE.png" alt="Pack Despertar" className="w-full max-w-xs rounded-lg shadow-2xl shadow-yellow-500/20" data-id="element-894" />
              </div>

              <div className="text-center mb-6" data-id="element-895">
                <p className="text-gray-500 line-through text-lg" data-id="element-896">$96.94</p>
                <div className="flex items-baseline justify-center gap-3" data-id="element-897">
                  <div className="text-5xl font-bold text-white" data-id="element-898">$27</div>
                </div>
                <p className="text-sm text-gray-400" data-id="element-899">Oferta especial</p>
              </div>

              <div className="flex-1 space-y-4 mb-8" data-id="element-900">
                <p className="font-semibold text-white" data-id="element-901">
                  Incluye todo lo anterior + integración profunda:
                </p>
                <ul className="space-y-3" data-id="element-902">
                  <li className="flex items-start gap-3 text-gray-300" data-id="element-903">
                    <Check className="w-5 h-5 text-yellow-500 flex-shrink-0" data-id="element-904" />
                    ¿Estás listo para jugar? (Audio + eBook)
                  </li>
                  <li className="flex items-start gap-3 text-gray-300" data-id="element-905">
                    <Check className="w-5 h-5 text-yellow-500 flex-shrink-0" data-id="element-906" />
                    <span className="font-bold text-white" data-id="element-907">
                      Meditaciones guiadas (audio binaural)
                    </span>
                  </li>
                  <li className="flex items-start gap-3 text-gray-300" data-id="element-908">
                    <Check className="w-5 h-5 text-yellow-500 flex-shrink-0" data-id="element-909" />
                    <span data-id="element-910">
                      BONUS:{' '}
                      <span className="font-bold text-white" data-id="element-911">
                        DMT — La Molécula de Dios
                      </span>{' '}
                      (audio + eBook)
                    </span>
                  </li>
                </ul>
              </div>

              <a href="https://www.voicesoffreedomus.com/cart/45290003792058:1" className="block w-full bg-yellow-500 hover:bg-yellow-400 text-black font-bold text-center py-4 rounded-xl transition-colors shadow-lg hover:shadow-yellow-500/20" data-id="element-912">
                OBTENER PACK DESPERTAR
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Value / Justification */}
      <section className="relative z-10 py-16 px-4 bg-black text-center" data-id="element-913">
        <div className="max-w-3xl mx-auto" data-id="element-914">
          <p className="text-xl text-gray-300 mb-6" data-id="element-915">
            Esto vale "10x" por una razón simple:
          </p>
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-6" data-id="element-916">
            una vez que recuerdas, nada externo puede controlarte igual.
          </h3>
          <p className="text-lg text-gray-400" data-id="element-917">
            No es entretenimiento. Es una actualización del sistema operativo
            interno.
          </p>
        </div>
      </section>

      {/* Guarantee */}
      <section className="relative z-10 py-20 px-4 bg-white text-black" data-id="element-918">
        <div className="max-w-4xl mx-auto" data-id="element-919">
          <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-920">
            <div className="flex-shrink-0" data-id="element-921">
              <Shield className="w-24 h-24 text-green-600" data-id="element-922" />
            </div>
            <div className="flex-1 text-center md:text-left" data-id="element-923">
              <h2 className="text-3xl font-bold mb-4" data-id="element-924">
                Mi promesa: "Recuerda Quién Eres"
              </h2>
              <p className="text-lg mb-6" data-id="element-925">
                Si este libro no despierta un cambio genuino en tu consciencia
                dentro de <span className="font-bold" data-id="element-926">7 días</span>, envía un
                correo a soporte con el asunto "Solicitud de Reembolso" y
                recibirás un reembolso completo dentro de 24 horas — sin
                preguntas.
              </p>
              <div className="bg-green-100 border-l-4 border-green-500 p-4 rounded-r-lg" data-id="element-927">
                <p className="font-medium text-green-800" data-id="element-928">
                  No arriesgas nada. La única forma de perder es permanecer
                  dormido.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Urgency */}
      <section className="relative z-10 py-20 px-4 bg-red-900/20 border-y border-red-900/30" data-id="element-929">
        <div className="max-w-3xl mx-auto text-center" data-id="element-930">
          <h2 className="text-3xl font-bold text-red-400 mb-6" data-id="element-931">
            Oferta por tiempo limitado
          </h2>
          <p className="text-lg text-gray-300 mb-8" data-id="element-932">
            Esta edición especial de lanzamiento es limitada. Cuando se agote
            esta primera ventana, el acceso vuelve a su precio normal.
          </p>
          <p className="text-xl font-medium text-white" data-id="element-933">
            La consciencia se está acelerando — el próximo ciclo no esperará.{' '}
            <span className="text-red-400 font-bold block mt-2" data-id="element-934">
              Retrasar solo alimenta el programa.
            </span>
          </p>
        </div>
      </section>

      {/* Final Decision */}
      <section className="relative z-10 py-20 px-4 bg-black" data-id="element-935">
        <div className="max-w-4xl mx-auto text-center" data-id="element-936">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-12" data-id="element-937">
            Estás en una encrucijada:
          </h2>
          <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-938">
            <div className="bg-gray-900 p-8 rounded-xl border border-gray-800 opacity-70" data-id="element-939">
              <h3 className="text-xl font-bold text-gray-400 mb-4" data-id="element-940">Camino 1</h3>
              <p className="text-gray-500" data-id="element-941">
                Seguir jugando ciego… repitiendo los mismos ciclos.
              </p>
            </div>
            <div className="bg-teal-900/30 p-8 rounded-xl border border-teal-500/50" data-id="element-942">
              <h3 className="text-xl font-bold text-teal-400 mb-4" data-id="element-943">Camino 2</h3>
              <p className="text-white" data-id="element-944">Despertar y jugar conscientemente.</p>
            </div>
          </div>

          <p className="text-lg text-gray-300 mb-8" data-id="element-945">
            Haz clic en el botón dorado para comenzar. En dos minutos tendrás
            acceso instantáneo al libro que ya cambió innumerables vidas.
          </p>

          <button onClick={() => scrollToSection('pricing')} className="w-full md:w-auto bg-yellow-500 hover:bg-yellow-400 text-black font-bold text-xl px-12 py-5 rounded-full shadow-xl transition-transform transform hover:scale-105 mb-6" data-id="element-946">
            SÍ — ESTOY LISTO PARA JUGAR
          </button>

          <p className="text-sm text-gray-500" data-id="element-947">
            ✓ Garantía de devolución de dinero (30 días en checkout, y/o 7 días
            "Recuerda Quién Eres" como promesa de lectura)
          </p>
        </div>
      </section>

      {/* FAQ */}
      <section className="relative z-10 py-20 px-4 bg-gray-900" data-id="element-948">
        <div className="max-w-3xl mx-auto" data-id="element-949">
          <h2 className="text-3xl font-bold text-center text-white mb-12" data-id="element-950">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-6" data-id="element-951">
            {[{
            q: '¿Para quién es esto?',
            a: 'Para cualquiera que sienta que el mundo es un juego que no entiende… y quiera recordar cómo jugar despierto, sin volverse dependiente de nadie.'
          }, {
            q: '¿Necesito ser "espiritual"?',
            a: 'No. Solo necesitas curiosidad y el coraje de cuestionar lo que te programaron a creer.'
          }, {
            q: '¿Cuánto tiempo tomará ver resultados?',
            a: 'Muchas personas sienten un cambio dentro de los primeros capítulos, cuando dejan de identificarse con el personaje y reconocen al observador.'
          }, {
            q: '¿Está conectado con la religión?',
            a: 'No. Es un marco universal que une experiencia directa, misticismo y un lenguaje moderno.'
          }, {
            q: '¿Esto promueve el uso de DMT?',
            a: 'No. El material se presenta como marco educativo y cultural dentro del tema de consciencia. El manual funciona sin necesidad de nada externo.'
          }].map((faq, i) => <div key={i} className="border-b border-gray-800 pb-6" data-id="element-952">
                <h3 className="text-lg font-bold text-teal-400 mb-2" data-id="element-953">
                  P: {faq.q}
                </h3>
                <p className="text-gray-300" data-id="element-954">R: {faq.a}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Final Remind */}
      <section className="relative z-10 py-20 px-4 bg-black text-center" data-id="element-955">
        <div className="max-w-2xl mx-auto" data-id="element-956">
          <h3 className="text-2xl font-bold text-white mb-6" data-id="element-957">
            ¿Aún indeciso? Recuerda:
          </h3>
          <ul className="text-left inline-block space-y-3 mb-8 text-gray-300" data-id="element-958">
            <li className="flex items-center gap-2" data-id="element-959">
              <Check className="w-5 h-5 text-green-500" data-id="element-960" /> Estás protegido por
              una garantía del 100%
            </li>
            <li className="flex items-center gap-2" data-id="element-961">
              <Check className="w-5 h-5 text-green-500" data-id="element-962" /> Obtienes acceso
              instantáneo hoy
            </li>
            <li className="flex items-center gap-2" data-id="element-963">
              <Check className="w-5 h-5 text-green-500" data-id="element-964" /> El único riesgo es
              seguir jugando ciego
            </li>
          </ul>
          <div className="mb-8" data-id="element-965">
            <button onClick={() => scrollToSection('pricing')} className="bg-white text-black font-bold px-8 py-3 rounded-full hover:bg-gray-200 transition-colors" data-id="element-966">
              ESTOY LISTO PARA RECORDAR
            </button>
          </div>
          <p className="text-gray-400 italic" data-id="element-967">
            P.D. Tu despertar no comienza cuando terminas el libro. Comienza en
            el momento en que dices{' '}
            <span className="text-white font-bold" data-id="element-968">sí</span>.
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="relative z-10 py-12 px-4 border-t border-gray-900 bg-black text-center text-gray-600 text-sm" data-id="element-969">
        <p className="mb-4" data-id="element-970">
          © 2025–2026 Nicolás Pereira & Gabriel Beltrán — Todos los derechos
          reservados.
        </p>
        <p data-id="element-971">
          Descargo de responsabilidad: contenido educativo. Resultados
          individuales pueden variar.
        </p>
      </footer>
    </div>;
}
export function LP2Page() {
  return <LanguageProvider data-id="element-972">
      <LP2Content data-id="element-973" />
    </LanguageProvider>;
}